<script setup>
	import Skeleton from 'primevue/skeleton'
	import PublicationTypeValues from '~/values/PublicationTypeValues.js'

	const $route = useRoute()
	const runtimeConfig = useRuntimeConfig()
	const { locale } = useI18n()
	const countries = ref([])
	const countrySelected = computed(() => {
		return countries.value.find(
			(country) =>
				country.code === String(countrySelectedState.value).toUpperCase()
		)
	})
	const countriesSSR = useState('countries')
	const countrySelectedState = useState('countrySelected', () => locale.value)
	const globalSettingDialog = ref(null)
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}

	onMounted(() => {
		countries.value = countriesSSR.value
		if (!countrySelectedState.value) {
			globalSettingDialog.value.showDialog()
		}
	})
</script>
<template>
	<footer class="relative">
		<div
			@click="scrollToTop"
			class="absolute right-12 top-12 border-b-2 text-xl cursor-pointer"
		>
			Ir Arriba
		</div>
		<div class="container pt-16">
			<div
				class="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-0 pb-6 md:pb-36 px-6 md:px-0"
			>
				<div class="space-y-5">
					<div class="font-semibold text-xl">{{ $t('Enlaces') }}</div>
					<ul class="list-none space-y-3 font-light">
						<NuxtLink
							v-for="publicationType in PublicationTypeValues.getList()"
							:key="publicationType"
							:to="{
								name: `type-tickets-dateId___${locale}`,
								params: {
									type: publicationType.value,
								},
							}"
							custom
							v-slot="{ href, navigate }"
						>
							<li>
								<span
									v-if="$route.params.type === publicationType.value"
									class="text-xl text-red-600"
									>&#183; </span
								><a :href="href" @click="navigate">{{
									publicationType.label_plural
								}}</a>
							</li>
						</NuxtLink>
					</ul>
				</div>
				<!-- <div class="space-y-5">
          <div class="font-semibold text-xl">Recursos</div>
          <ul class="list-none space-y-3 font-light">
            <li><NuxtLink to="/about">Nosotros</NuxtLink></li>
            <li><a href="https://blog.tickea.com">Tickea Blog</a></li>
            <li><a href="https://jobs.tickea.com">Jobs</a></li>
            <li><NuxtLink to="/help">Ayuda y Soporte</NuxtLink></li>
            <li><NuxtLink to="/sell">Vender en Tickea</NuxtLink></li>
            <li><NuxtLink to="/producers">Tickea Producers</NuxtLink></li>
            <li><NuxtLink to="/artists">Tickea Artists</NuxtLink></li>
            <li><NuxtLink to="/platform">Plataforma</NuxtLink></li>
            <li><a href="https://developers.tickea.com">Developers</a></li>
          </ul>
        </div> -->
				<div class="space-y-5">
					<div class="font-semibold text-xl">Legal</div>
					<ul class="list-none space-y-3 font-light">
						<li>
							<NuxtLink to="/terms-and-conditions"
								>Términos y Condiciones
							</NuxtLink>
						</li>
						<li>
							<NuxtLink to="/privacy-policy">Política de Privacidad</NuxtLink>
						</li>
						<li>
							<NuxtLink to="/use-conditions">Condiciones de Uso</NuxtLink>
						</li>
						<li>
							<NuxtLink to="/cookie-policy">Política de Cookies</NuxtLink>
						</li>
						<li>
							<NuxtLink to="/cancel-policy">Política de Cancelación</NuxtLink>
						</li>
					</ul>
				</div>
				<div class="flex flex-col justify-end space-y-5">
					<div class="flex items-center space-x-5 justify-center">
						<a :href="runtimeConfig.public.playstoreUrl" target="_blank"
							><svg
								class="w-[45px] fill-gray-800 dark:fill-white"
								viewBox="0 0 24 24"
							>
								<path
									d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"
								/>
							</svg>
						</a>
						<a :href="runtimeConfig.public.applestoreUrl" target="_blank"
							><svg
								class="w-[45px] fill-gray-800 dark:fill-white"
								viewBox="0 0 24 24"
							>
								<path
									d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z"
								/>
							</svg>
						</a>
					</div>
					<div class="font-bold text-xl text-center">¡Descarga tu App!</div>
				</div>
			</div>
			<div
				class="flex flex-col md:flex-row justify-between border-t border-t-gray-200 dark:border-t-gray-700 pt-12"
			>
				<div class="flex flex-col md:flex-row items-center gap-5">
					<NuxtLink :to="`/${locale}`"
						><Logo class="w-[130px]" alt="Logo"
					/></NuxtLink>
					<div class="opacity-80 xs:text-sm">
						© 2024 {{ runtimeConfig.public.siteName }} Platform, Inc. All rights
						reserved.
					</div>
				</div>
				<div class="flex items-center justify-between gap-5 my-8 md:my-0">
					<ClientOnly fallback-tag="span">
						<div
							class="flex items-center space-x-2 cursor-pointer p-3 rounded-xl bg-transparent hover:text-gray-50 hover:bg-gray-300 dark:text-white dark:hover:bg-gray-800 transition-all"
							@click="$refs.globalSettingDialog.showDialog()"
						>
							<div class="flex items-center space-x-5">
								<div>
									<img
										:src="countrySelected?.icon_url"
										:alt="countrySelected?.name"
										class="w-8 h-8"
									/>
								</div>
								<div>{{ countrySelected?.name }}</div>
							</div>
							<div>
								<i class="mdi mdi-chevron-down"></i>
							</div>
						</div>
						<template #fallback>
							<div class="flex items-center space-x-2">
								<div class="flex items-center space-x-5">
									<Skeleton shape="circle" width="2rem" height="2rem" />
									<Skeleton width="5rem" height=".6rem" />
								</div>
								<div>
									<Skeleton shape="circle" width=".8rem" height=".8rem" />
								</div>
							</div>
						</template>
					</ClientOnly>
					<div class="flex items-center gap-5">
						<svg
							class="fill-gray-800 dark:fill-white"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M19.3214 5.56219C19.1695 5.4837 19.0217 5.39765 18.8784 5.30438C18.4618 5.02896 18.0799 4.70445 17.7408 4.33781C16.8923 3.36703 16.5754 2.38219 16.4587 1.69266H16.4634C16.3659 1.12031 16.4062 0.75 16.4123 0.75H12.5479V15.6928C12.5479 15.8934 12.5479 16.0917 12.5395 16.2877C12.5395 16.312 12.5372 16.3345 12.5358 16.3608C12.5358 16.3716 12.5358 16.3828 12.5334 16.3941C12.5334 16.3969 12.5334 16.3997 12.5334 16.4025C12.4927 16.9386 12.3208 17.4566 12.0329 17.9107C11.7451 18.3648 11.35 18.7413 10.8825 19.0069C10.3952 19.2841 9.84415 19.4295 9.28357 19.4288C7.4831 19.4288 6.02388 17.9606 6.02388 16.1475C6.02388 14.3344 7.4831 12.8663 9.28357 12.8663C9.62439 12.8659 9.96311 12.9196 10.2872 13.0252L10.2919 9.09047C9.30811 8.9634 8.30872 9.04158 7.35671 9.32008C6.4047 9.59858 5.52074 10.0714 4.7606 10.7086C4.09454 11.2873 3.53457 11.9778 3.10591 12.7491C2.94279 13.0303 2.32732 14.1605 2.25279 15.9947C2.20591 17.0358 2.51857 18.1144 2.66763 18.5602V18.5695C2.76138 18.832 3.12466 19.7278 3.71669 20.483C4.19409 21.0887 4.75811 21.6208 5.3906 22.0622V22.0528L5.39997 22.0622C7.27076 23.3334 9.34498 23.25 9.34498 23.25C9.70404 23.2355 10.9069 23.25 12.2728 22.6027C13.7878 21.885 14.6503 20.8158 14.6503 20.8158C15.2013 20.1769 15.6394 19.4488 15.9459 18.6628C16.2956 17.7436 16.4123 16.6411 16.4123 16.2005V8.27297C16.4592 8.30109 17.0836 8.71406 17.0836 8.71406C17.0836 8.71406 17.9831 9.29063 19.3865 9.66609C20.3934 9.93328 21.75 9.98953 21.75 9.98953V6.15328C21.2747 6.20484 20.3095 6.05484 19.3214 5.56219Z"
							/>
						</svg>
						<svg
							class="fill-gray-800 dark:fill-white"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9.09998 2.3335H18.9C22.6333 2.3335 25.6666 5.36683 25.6666 9.10016V18.9002C25.6666 20.6948 24.9537 22.4159 23.6847 23.6849C22.4157 24.9539 20.6946 25.6668 18.9 25.6668H9.09998C5.36665 25.6668 2.33331 22.6335 2.33331 18.9002V9.10016C2.33331 7.30553 3.04623 5.5844 4.31522 4.31541C5.58422 3.04641 7.30535 2.3335 9.09998 2.3335ZM8.86665 4.66683C7.75274 4.66683 6.68445 5.10933 5.8968 5.89698C5.10915 6.68463 4.66665 7.75292 4.66665 8.86683V19.1335C4.66665 21.4552 6.54498 23.3335 8.86665 23.3335H19.1333C20.2472 23.3335 21.3155 22.891 22.1032 22.1033C22.8908 21.3157 23.3333 20.2474 23.3333 19.1335V8.86683C23.3333 6.54516 21.455 4.66683 19.1333 4.66683H8.86665ZM20.125 6.41683C20.5118 6.41683 20.8827 6.57048 21.1562 6.84397C21.4297 7.11746 21.5833 7.48839 21.5833 7.87516C21.5833 8.26194 21.4297 8.63287 21.1562 8.90636C20.8827 9.17985 20.5118 9.3335 20.125 9.3335C19.7382 9.3335 19.3673 9.17985 19.0938 8.90636C18.8203 8.63287 18.6666 8.26194 18.6666 7.87516C18.6666 7.48839 18.8203 7.11746 19.0938 6.84397C19.3673 6.57048 19.7382 6.41683 20.125 6.41683ZM14 8.16683C15.5471 8.16683 17.0308 8.78141 18.1248 9.87537C19.2187 10.9693 19.8333 12.4531 19.8333 14.0002C19.8333 15.5473 19.2187 17.031 18.1248 18.125C17.0308 19.2189 15.5471 19.8335 14 19.8335C12.4529 19.8335 10.9692 19.2189 9.87519 18.125C8.78123 17.031 8.16665 15.5473 8.16665 14.0002C8.16665 12.4531 8.78123 10.9693 9.87519 9.87537C10.9692 8.78141 12.4529 8.16683 14 8.16683ZM14 10.5002C13.0717 10.5002 12.1815 10.8689 11.5251 11.5253C10.8687 12.1817 10.5 13.0719 10.5 14.0002C10.5 14.9284 10.8687 15.8187 11.5251 16.475C12.1815 17.1314 13.0717 17.5002 14 17.5002C14.9282 17.5002 15.8185 17.1314 16.4749 16.475C17.1312 15.8187 17.5 14.9284 17.5 14.0002C17.5 13.0719 17.1312 12.1817 16.4749 11.5253C15.8185 10.8689 14.9282 10.5002 14 10.5002Z"
							/>
						</svg>
						<svg
							class="fill-gray-800 dark:fill-white"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M18.5915 1H21.8104L14.7428 9.91144L23 22H16.5202L11.4469 14.6538L5.63879 22H2.41986L9.90736 12.4686L2 1H8.64079L13.2243 7.7107L18.5915 1ZM17.4648 19.9078H19.2493L7.7031 3.01476H5.78574L17.4648 19.9078Z"
							/>
						</svg>
						<svg
							class="fill-gray-800 dark:fill-white"
							width="28"
							height="28"
							viewBox="0 0 28 28"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M11.6666 17.5002L17.7216 14.0002L11.6666 10.5002V17.5002ZM25.1533 8.36516C25.305 8.9135 25.41 9.6485 25.48 10.5818C25.5616 11.5152 25.5966 12.3202 25.5966 13.0202L25.6666 14.0002C25.6666 16.5552 25.48 18.4335 25.1533 19.6352C24.8616 20.6852 24.185 21.3618 23.135 21.6535C22.5866 21.8052 21.5833 21.9102 20.0433 21.9802C18.5266 22.0618 17.1383 22.0968 15.855 22.0968L14 22.1668C9.11165 22.1668 6.06665 21.9802 4.86498 21.6535C3.81498 21.3618 3.13831 20.6852 2.84665 19.6352C2.69498 19.0868 2.58998 18.3518 2.51998 17.4185C2.43831 16.4852 2.40331 15.6802 2.40331 14.9802L2.33331 14.0002C2.33331 11.4452 2.51998 9.56683 2.84665 8.36516C3.13831 7.31516 3.81498 6.6385 4.86498 6.34683C5.41331 6.19516 6.41665 6.09016 7.95665 6.02016C9.47331 5.9385 10.8616 5.9035 12.145 5.9035L14 5.8335C18.8883 5.8335 21.9333 6.02016 23.135 6.34683C24.185 6.6385 24.8616 7.31516 25.1533 8.36516Z"
							/>
						</svg>
					</div>
				</div>
			</div>
			<div class="flex justify-center py-12 sm:pt-0">
				<ColorModePicker />
			</div>
		</div>
	</footer>
	<GlobalSettingDialog ref="globalSettingDialog" />
</template>

<style scoped>
	footer {
		@apply bg-gray-100 text-gray-700;
		@apply dark:bg-[#1C1C1C] dark:text-gray-50;
	}
</style>
